<template>
  <router-view />
  <PwaInstallPrompt />
</template>

<script setup lang="ts">
import PwaInstallPrompt from '@/Partials/Molecules/Base/PwaInstallPrompt.vue';
</script>

<style lang="scss">
@import '@/Scss/main';

#app {
  width: 100%;
  height: 100%;
}
</style>
